import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-experience-modal',
  templateUrl: './experience-modal.component.html',
  styleUrls: ['./experience-modal.component.css']
})
export class ExperienceModalComponent implements OnInit {

  isModalVisible: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  OpenModal(){    
    this.isModalVisible = true;
  }

  CloseModal(){
    this.isModalVisible = false;    
  }

}
